import { type FC, useMemo } from 'react'

import { useFetchPatientMedicalIssuesQuery } from 'features/Schedule/api/medicalIssues.api'

import type { PersonOption } from '../ProviderField'
import { SeriesCreatePanel } from './create/SeriesCreatePanel'
import { SeriesEditPanel } from './edit/SeriesEditPanel'
import type { SeriesTab } from './useSeriesTab'

type Props = {
  tab: Pick<SeriesTab, 'create' | 'edit'>
  doctorOptions: PersonOption[]
  patientId: number | null
}

// The patient route already answers with open problems only, as the booking picker shows them.
export const SeriesSection: FC<Props> = ({ tab, doctorOptions, patientId }) => {
  const { data } = useFetchPatientMedicalIssuesQuery(
    { patientId: patientId ?? 0 },
    { skip: !patientId },
  )
  const openProblems = useMemo(
    () => (data ?? []).map((issue) => ({ id: issue.id, title: issue.title })),
    [data],
  )

  if (tab.create) {
    return (
      <SeriesCreatePanel
        create={tab.create}
        doctorOptions={doctorOptions}
        problems={openProblems}
      />
    )
  }
  // An idle edit has nothing to show; it only becomes active on the Series tab.
  if (tab.edit && tab.edit.status !== 'idle') {
    return (
      <SeriesEditPanel edit={tab.edit} doctorOptions={doctorOptions} openProblems={openProblems} />
    )
  }
  return null
}
